import { render } from "./ServiceTermsPrivacy.vue?vue&type=template&id=5a50e17d&scoped=true&ts=true"
import script from "./ServiceTermsPrivacy.vue?vue&type=script&lang=ts"
export * from "./ServiceTermsPrivacy.vue?vue&type=script&lang=ts"

import "./ServiceTermsPrivacy.vue?vue&type=style&index=0&id=5a50e17d&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a50e17d"]])

export default __exports__